import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { HomePageBody } from "../components/HomePageBody";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: Immutable<templates.HomePageTemplate>,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <HomePageBody {...props} />
    </PageSkeleton>
);
